<template>
    <div>
        <notification-modal :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            messageTitle: 'Request cancelled',
            message: 'Request <u>#'+VueStore.state.requests.formData[0].job_no+'</u> has been cancelled.',
            notificationType: 'warning',
            firstAction: 'close',
            firstActionText: '&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;',
            resetVariable: 'showRequestCancelled'
        }
    },
}
</script>